import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/interfaces/cliente.interface';
import { Imagen } from 'src/app/interfaces/imagen.interface';
import { Mensaje } from 'src/app/interfaces/mensaje.interface';
import { Respuesta } from 'src/app/interfaces/respuesta.interface';
import { Vehiculo } from 'src/app/interfaces/vehiculo.interface';
import { ClientesService } from 'src/app/services/clientes.service';
import { ImagenesService } from 'src/app/services/imagenes.service';
import { MisFuncionesService } from 'src/app/services/mis-funciones.service';
import { VehiculosService } from 'src/app/services/vehiculos.service';
import { TabDirective } from 'src/app/shared/directives/tab.directive';
import { environment } from 'src/environments/environment';

@Component({
   selector: 'app-nuevo-vehiculo',
   templateUrl: './nuevo-vehiculo.component.html',
   styleUrls: ['./nuevo-vehiculo.component.css']
})
export class NuevoVehiculoComponent implements OnInit {

   @Output() onCancel: EventEmitter<number> = new EventEmitter();
   @Output() onCodigoVehiculo: EventEmitter<string> = new EventEmitter();
   @Output() onCodigoCliente: EventEmitter<string> = new EventEmitter();
   @Input() cliente: Cliente = {};


   // NECESARIO PARA ACTIVAR TABULADOR
   @ViewChildren(TabDirective) inputs!: QueryList<TabDirective>;

   // VARIABLES DE COMPONENTES  
   public mensaje: Mensaje = {};
   public activarBuscador: boolean = false;
   public activarSpinner: boolean = false;
   public vehiculos: Vehiculo[] = [];
   public clientes: Cliente[] = [];
   // public clienteActivo: Cliente = {};
   public imagenesCarrusel: Imagen[] = [];
   public matriculaExistente: boolean = false;

   // VARIABLES DEL FORMULARIO
   public idActivo: number = 0;
   public vehiculoActivo: Vehiculo = {};
   public formulario: FormGroup = this.fb.group({
      codigo: ['', [Validators.required, Validators.minLength(2)]],
      marca: [''],
      modelo: [''],
      color: [''],
      // codigoCliente: [''],
      bastidor: [''],
      anoModelo: [0],
      kms: [0],
      observaciones: [''],
      bloqueado: [0],
      motivoBloqueo: [''],
      fechaBaja: [''],
   });

   constructor(
      private activatedRoute: ActivatedRoute,
      private clientesService: ClientesService,
      private fb: FormBuilder,
      private imagenesService: ImagenesService,
      private misFuncionesService: MisFuncionesService,
      private router: Router,
      private titleService: Title,
      private vehiculosService: VehiculosService,
   ) { }

   /* -------------------------------------------------------------------------- */
   /*                      NECESARIO PARA ACTIVAR TABULADOR                      */
   /* -------------------------------------------------------------------------- */

   ngAfterViewInit():void {
      this.initTab();
      // this.activatedRoute.params
      //    .subscribe(async ({ id }) => {
      //       if (id > 0) {
      //          this.idActivo = id;
      //          this.cargarVehiculo(id)
      //       }
      //    });
   }

   initTab() {
      const controls = this.inputs.toArray();
      for (let i = 0; i < controls.length - 1; i++) {
         controls[i].nextControl = controls[i + 1].self;
      }
   }

   ngOnInit(): void {
      this.titleService.setTitle("Atpv: Vehículos");
      if (!this.cliente.id){this.crearCliente();}

   }

   /* -------------------------------------------------------------------------- */
   /*                                   CARGAS                                   */
   /* -------------------------------------------------------------------------- */


   cargarImagenesCarrusel() {
      // this.activarSpinner = true;

      this.imagenesCarrusel = [];
      this.imagenesService.getImagenesMatricula(this.vehiculoActivo.matricula!)
         .subscribe(resp => {
            if (resp.status == 200) {
               this.imagenesCarrusel = resp.detalle;
            }
            // this.activarSpinner = false
         });
   }

  



   /* -------------------------------------------------------------------------- */
   /*                                VALIDACIONES                                */
   /* -------------------------------------------------------------------------- */

   campoNoValido(campo: string) {
      return (this.formulario.controls[campo].errors && this.formulario.controls[campo].touched)
   }

   validarCodigo() {
      const codigo = this.formulario.get('codigo')!.value;
      if (codigo.length > 0) {
         this.activarSpinner = true;
         this.vehiculosService.getVehiculoCodigo(codigo)
            .subscribe(
               resp => {
                  if (resp.status != 200) {
                     this.matriculaExistente = false;
                     if (this.idActivo != 0) {
                        this.mensaje.textoAlert = resp.detalle;
                        this.mensaje.persistente = true;
                        this.mensaje.alert = true;
                     }
                  } else {
                     this.matriculaExistente = true;
                  }
                  this.activarSpinner = false;
               }
            );
      }
   }

  

   comprobarCliente() {
      if (this.vehiculoActivo?.idCliente! > 0) {
         return true;
      } else {
         this.crearCliente();
         return false;
      }
   }

   /* -------------------------------------------------------------------------- */
   /*                               ACTUALIZACIONES                              */
   /* -------------------------------------------------------------------------- */

  

   actualizarVehiculoActivo() {
      this.vehiculoActivo.codigo = this.formulario.get('codigo')!.value;
      this.vehiculoActivo.matricula = this.formulario.get('codigo')!.value;
      this.vehiculoActivo.codigoCliente = this.cliente.codigo;
      this.vehiculoActivo.idCliente = this.cliente.id;
      this.vehiculoActivo.nombreFiscal = this.cliente.nombreFiscal;
      this.vehiculoActivo.marca = this.formulario.get('marca')!.value;
      this.vehiculoActivo.modelo = this.formulario.get('modelo')!.value;
      this.vehiculoActivo.color = this.formulario.get('color')!.value;
      this.vehiculoActivo.bastidor = this.formulario.get('bastidor')!.value;
      this.vehiculoActivo.anoModelo = this.formulario.get('anoModelo')!.value;
      this.vehiculoActivo.kms = this.formulario.get('kms')!.value;
      this.vehiculoActivo.observaciones = this.formulario.get('observaciones')!.value;
      this.vehiculoActivo.bloqueado = (this.formulario.get('bloqueado')!.value == true) ? 1 : 0;
      this.vehiculoActivo.motivoBloqueo = this.formulario.get('motivoBloqueo')!.value;
      this.vehiculoActivo.fechaBaja = this.formulario.get('fechaBaja')!.value;
   }








   /* -------------------------------------------------------------------------- */
   /*                           FUNCIONES DEL FORMULARIO                          */
   /* -------------------------------------------------------------------------- */

   async nuevoCodigoCliente() {
      const resp: Respuesta = await this.clientesService.getNextClienteCodigo().toPromise();
               if (resp.status != 200) {
                  console.log(resp.detalle);
               } else {
                  this.cliente.codigo = resp.detalle;
               }
   }

   crearCliente() {

      this.mensaje.textoDanger = 'No hay cliente asociado al vehículo, ¿Desea crear un cliente Provisional?'
      this.mensaje.persistente = true;
      this.mensaje.botones = true;
      this.mensaje.comandoCancelar = 'this.mensaje.danger = false; this.cancelar()';
      this.mensaje.comandoAceptar = 'this.crearClienteConfirmado();';
      this.mensaje.danger = true;
   }

   async crearClienteConfirmado(){
      await this.nuevoCodigoCliente();

      const cliente: Cliente = {
         id: 0,
         codigo: this.cliente.codigo,
         nombreFiscal: 'Cliente Provisional',
         cif: this.cliente.codigo,
         idFormaPago: 1,
         idTiposIvaCliente: 1,

      };

      const resp: Respuesta = await this.clientesService.nuevoJson(cliente).toPromise();   
      if (resp.status == 200){
         const resp2:Respuesta = await this.clientesService.getClienteCodigo(cliente.codigo!).toPromise();
         if (resp2.status != 200){
            console.log(resp2.detalle);
         }else{
            this.cliente = resp2.detalle;
         }
      }else{
         console.log(resp.detalle);
      }
   }

   

   setearCliente() {
      this.formulario.reset({
         codigo: this.formulario.get('codigo')!.value,
         codigoCliente: this.cliente.codigo,
         marca: this.formulario.get('marca')!.value,
         modelo: this.formulario.get('modelo')!.value,
         color: this.formulario.get('color')!.value,
         bastidor: this.formulario.get('bastidor')!.value,
         anoModelo: this.formulario.get('anoModelo')!.value,
         kms: this.formulario.get('kms')!.value,
         observaciones: this.formulario.get('observaciones')!.value,
         bloqueado: (this.formulario.get('bloqueado')!.value == true) ? 1 : 0,
         motivoBloqueo: this.formulario.get('motivoBloqueo')!.value,
         fechaBaja: this.formulario.get('fechaBaja')!.value,
      });

   }

   resetearFormulario() {
      this.formulario.reset({
         codigo: '',
         marca: '',
         modelo: '',
         color: '',
         codigoCliente: '',
         bastidor: '',
         anoModelo: 0,
         kms: 0,
         observaciones: '',
         bloqueado: 0,
         motivoBloqueo: '',
         fechaBaja: null,
      });
      this.idActivo = 0;
      this.vehiculoActivo = {};
      this.cliente = {};
   }



   irVehiculoNuevo() {
      this.resetearFormulario();
      this.router.navigateByUrl(`/mantenimientos/manVehiculos/0`);

   }

   grabar() {
      if (this.formulario.valid && this.cliente.id && this.cliente.codigo && !this.matriculaExistente) {
         // if (this.comprobarCliente()) {
            this.actualizarVehiculoActivo();
            this.activarSpinner = true;
            if (this.idActivo == 0) {
               // CREAR NUEVA VEHÍCULO
               this.vehiculosService.nuevo(this.vehiculoActivo)
                  .subscribe(
                     resp => {
                        if (resp.status != 200) {
                           this.mensaje.textoAlert = resp.detalle;
                           this.mensaje.alert = true;
                        } else {
                           this.mensaje.textoSuccess = resp.detalle;
                           this.mensaje.success = true;
                           this.idActivo = resp.ultimoId;

                           // this.irVehiculoNuevo();
                           // (environment.nuevoAlGrabar == true) ? this.irVehiculoNuevo() : this.router.navigateByUrl(`/mantenimientos/manVehiculos/${this.idActivo}`);
                           if (this.cliente.nombreFiscal == 'Cliente Provisional'){
                              this.onCodigoCliente.emit(this.cliente.codigo);
                           }else{
                              this.onCodigoVehiculo.emit(this.vehiculoActivo.codigo);
                           }
                        }
                        this.activarSpinner = false;
                     }
                  );
            } else {
               // ACTUALIZAR VEHÍCULO 
               this.vehiculosService.actualizar(this.vehiculoActivo)
                  .subscribe(
                     resp => {
                        if (resp.status != 200) {
                           this.mensaje.textoAlert = resp.detalle;
                           this.mensaje.alert = true;
                        } else {
                           this.mensaje.textoSuccess = resp.detalle;
                           this.mensaje.success = true;
                           // this.irVehiculoNuevo();
                           if (environment.nuevoAlGrabar == true) { this.irVehiculoNuevo() };
                           this.formulario.markAsPristine();

                        }
                        this.activarSpinner = false;
                     }
                  );
            }
         // }
      } else {
         this.mensaje.textoAlert = 'Errores en el formulario. Revise los campos.';
         this.mensaje.alert = true;
         return Object.values(this.formulario.controls).forEach(control => {
            if (control instanceof FormGroup) {
               return Object.values(control.controls).forEach(control => { control.markAsTouched() })
            } else {
               control.markAsTouched();
            }
         });
      }
   }


   /* -------------------------------------------------------------------------- */
   /*                               FUNCIONES HTML                               */
   /* -------------------------------------------------------------------------- */

   claseContenedor() {
      if (this.formulario.dirty) { return 'buscador traerAlFrente bordeContenedorRojo '; }
      return 'buscador fade-in-image traerAlFrente '
   }

   claseH2() {
      if (this.formulario.dirty) { return 'rojo'; }
      return '';
   }

   cancelar() {
      this.onCancel.emit(0);
   }

   /* -------------------------------------------------------------------------- */
   /*                           NECESARIO PARA MENSAJE                           */
   /* -------------------------------------------------------------------------- */

   controlBotones(evento: number) {
      this.mensaje.botones = false;
      this.mensaje.persistente = false;
      if (evento == 1) {
         eval(this.mensaje.comandoAceptar!);
      } else {
         eval(this.mensaje.comandoCancelar!);
      }
   }


}
